import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import Dashboard from 'portal/src/components/common/Dashboard';
import { BillReportDashboard } from 'portal/src/components/reports/BillReportDashboard';
import { DASHBOARD_SLUGS } from 'portal/src/constants/luzmoDashboards';

import { RouteDefinition } from './routeGenerator';

export const reportRouteDefinitions: RouteDefinition[] = [
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.REPORTS.ACCOUNT_DETAILS} />
    ),
    name: 'Account Details',
    path: NESTED_ROUTES.REPORTS.ACCOUNT_DETAILS,
  },
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.REPORTS.CALENDAR_NORMALIZED} />
    ),
    name: 'Calendar Normalized',
    path: NESTED_ROUTES.REPORTS.CALENDAR_NORMALIZED,
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.REPORTS.FACILITIES} />,
    name: 'Facilities',
    path: NESTED_ROUTES.REPORTS.FACILITIES,
  },
  {
    element: <BillReportDashboard />,
    name: 'Bills',
    path: NESTED_ROUTES.REPORTS.BILLS,
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.REPORTS.HISTORICAL_USAGE_COST}
      />
    ),
    name: 'Historical Usage and Cost',
    path: NESTED_ROUTES.REPORTS.HISTORICAL_USAGE_COST,
  },
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.REPORTS.TOTAL_ENERGY_COSTS} />
    ),
    name: 'Total Energy Costs',
    path: NESTED_ROUTES.REPORTS.TOTAL_ENERGY_COSTS,
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.REPORTS.LINE_ITEMS} />,
    name: 'Line Items',
    path: NESTED_ROUTES.REPORTS.LINE_ITEMS,
  },
];
